'use client';

import React from 'react';
import { BarChart3, TrendingUp, ShieldCheck, History } from 'lucide-react';
import type { ReportsTab } from '../page';
import Icon from '@/components/ui/AppIcon';


const TABS: { id: ReportsTab; label: string; icon: React.ElementType; description: string }[] = [
  { id: 'billable_hours', label: 'Billable Hours', icon: BarChart3, description: 'Invoice-linked hours by staff & role' },
  { id: 'utilization', label: 'Utilization Trends', icon: TrendingUp, description: 'Staffing coverage & overtime trends' },
  { id: 'credentials', label: 'Credential Compliance', icon: ShieldCheck, description: 'License & certification status export' },
  { id: 'history', label: 'Export History', icon: History, description: 'Audit trail of all generated reports' },
];

interface ReportsHeaderProps {
  activeTab: ReportsTab;
  onTabChange: (tab: ReportsTab) => void;
}

export default function ReportsHeader({ activeTab, onTabChange }: ReportsHeaderProps) {
  return (
    <div className="px-6 pt-6 pb-0 border-b border-border">
      <div className="flex items-start justify-between mb-4">
        <div>
          <h1 className="text-xl font-700 text-foreground tracking-tight">Reports & Analytics</h1>
          <p className="text-sm text-muted-foreground mt-0.5">
            Billable hours, staffing utilization, and credential compliance — tied to invoicing and audit logs
          </p>
        </div>
      </div>
      <div className="flex gap-1 -mb-px">
        {TABS.map((tab) => {
          const Icon = tab.icon;
          const active = activeTab === tab.id;
          return (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              className={`flex items-center gap-2 px-4 py-2.5 text-sm font-500 border-b-2 transition-colors whitespace-nowrap ${
                active
                  ? 'border-primary text-primary' :'border-transparent text-muted-foreground hover:text-foreground hover:border-border'
              }`}
            >
              <Icon size={15} />
              {tab.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
